import React, { useState } from 'react';
import PageLoadingSpinner from '../components/PageLoadingSpinner';

function FAQPage() {
  const [loading] = useState(false); // Remove setLoading

  return (
    <>
      <PageLoadingSpinner show={loading} fullscreen />
      <div className="container py-5">
        <h1 className="mb-4 text-center">Sıkça Sorulan Sorular (SSS)</h1>
        <div className="accordion" id="faqAccordion" style={{ maxWidth: 800, margin: '0 auto' }}>
          <div className="accordion-item">
            <h2 className="accordion-header" id="heading1">
              <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1" aria-expanded="true" aria-controls="collapse1">
                Katip Otomasyonu uzantısı nedir ve ne işe yarar?
              </button>
            </h2>
            <div id="collapse1" className="accordion-collapse collapse show" aria-labelledby="heading1" data-bs-parent="#faqAccordion">
              <div className="accordion-body">
                Katip Otomasyonu, isgkatip.csgb.gov.tr platformunda İş Güvenliği Uzmanı, İşyeri Hekimi ve Diğer Sağlık Personeli atamalarını ve ilgili raporları otomatikleştirmenize yardımcı olan bir Chrome uzantısıdır.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="heading2">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Uzantıyı kullanmak için neye ihtiyacım var?
              </button>
            </h2>
            <div id="collapse2" className="accordion-collapse collapse" aria-labelledby="heading2" data-bs-parent="#faqAccordion">
              <div className="accordion-body">
                Uzantıyı kullanabilmek için geçerli bir lisans anahtarınızın olması gerekmektedir. Lisans anahtarınızı Arkaya Arge Yazılım İnşaat Ticaret Ltd.Şti. üzerinden temin edebilirsiniz.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="heading3">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Lisans anahtarımı nasıl girerim?
              </button>
            </h2>
            <div id="collapse3" className="accordion-collapse collapse" aria-labelledby="heading3" data-bs-parent="#faqAccordion">
              <div className="accordion-body">
                Uzantıyı yükledikten sonra açılan ekranda size verilen lisans anahtarınızı girip “Gönder” butonuna tıklamanız yeterlidir.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="heading4">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Hangi verilerim saklanıyor?
              </button>
            </h2>
            <div id="collapse4" className="accordion-collapse collapse" aria-labelledby="heading4" data-bs-parent="#faqAccordion">
              <div className="accordion-body">
                Sadece lisans anahtarınız ve websitemize kayıt sırasında sizden istemiş olduğumuz bilgileriniz güvenli şekilde saklanır. Bu verileriniz, KVKK kapsamında korunur ve üçüncü kişilerle paylaşılmaz.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="heading5">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Uzantı verilerimi saklıyor mu veya bir yere gönderiyor mu?
              </button>
            </h2>
            <div id="collapse5" className="accordion-collapse collapse" aria-labelledby="heading5" data-bs-parent="#faqAccordion">
              <div className="accordion-body">
                Uzantı hiçbir verinizi kaydetmez ve başka bir sunucu ile paylaşmaz. Katip Otomasyonu uygulaması yalnızca elle yaptığınız işlemleri daha hızlı yapmanızı sağlar. Yalnızca lisans anahtarı, son kullanım tarihi gibi bilgilerin teyiti için lisans doğrulaması yapılır.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="heading6">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                Uzantı hangi işlemleri otomatikleştirir?
              </button>
            </h2>
            <div id="collapse6" className="accordion-collapse collapse" aria-labelledby="heading6" data-bs-parent="#faqAccordion">
              <div className="accordion-body">
                İş Güvenliği Uzmanı, İşyeri Hekimi ve Diğer Sağlık Personeli atama raporlarını, sözleşme kontrollerini ve ilgili raporların indirilmesini otomatikleştirir.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="heading7">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                Katip Otomasyounu uzantısı güvenli mi?
              </button>
            </h2>
            <div id="collapse7" className="accordion-collapse collapse" aria-labelledby="heading7" data-bs-parent="#faqAccordion">
              <div className="accordion-body">
                Evet. Uygulamamız Google Web Mağazası'nda yayınlandığı için düzenli olarak kod denetimlerinden geçmektedir. Güvenli olmadığı durumda Google uygulamanın mağazada yayınlanmasına izin vermez ve yayından kaldırır. Katip Otomasyonu resmi İSG-KATİP platformunun yerine geçmez, yalnızca kullanıcı işlemlerini kolaylaştırır. Tüm işlemler yine İSG-KATİP üzerinden gerçekleşmektedir.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="heading8">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse8" aria-expanded="false" aria-controls="collapse8">
                Destek veya yardım almak için nereye başvurabilirim?
              </button>
            </h2>
            <div id="collapse8" className="accordion-collapse collapse" aria-labelledby="heading8" data-bs-parent="#faqAccordion">
              <div className="accordion-body">
                Her türlü soru ve destek talepleriniz için <a href="mailto:info@katipotomasyonu.com">info@katipotomasyonu.com</a> adresine e-posta gönderebilirsiniz. Ayrıca hafta içi 10:00 - 19:00 saatleri arasında 501 544 8 544 numarasından bize WhatsApp veya telefon ile ulaşabilirsiniz.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="heading9">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse9" aria-expanded="false" aria-controls="collapse9">
                Ürün ile ilgili fatura alabilir miyim?
              </button>
            </h2>
            <div id="collapse9" className="accordion-collapse collapse" aria-labelledby="heading9" data-bs-parent="#faqAccordion">
              <div className="accordion-body">
                Tüm müşterilerimize satın alımlarından sonra fatura kesmekteyiz, kayıt esnasında fatura bilgilerinizi doğru şekilde paylaştığınızdan emin olunuz. Kayıt sırasında vergi bilgilerinizi hatalı girdiyseniz bizden e-posta, Whatsapp ya da telefon yoluyla destek isteyerek bilgilerinizi güncelleyebilirsiniz. KDV oranımız %20'dir.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="heading10">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse10" aria-expanded="false" aria-controls="collapse10">
                Katip Otomasyonu kullanırken 6331 sayılı İş Sağlığı ve Güvenliği Kanunu kapsamındaki sorumluluklarımızda bir değişiklik olur mu?
              </button>
            </h2>
            <div id="collapse10" className="accordion-collapse collapse" aria-labelledby="heading10" data-bs-parent="#faqAccordion">
              <div className="accordion-body">
                    Katip Otomasyonu, sizin yerinize sorumluluk üstlenmez; yalnızca İSG-KATİP üzerindeki günlük işlemlerinizi hızlandıran ve kolaylaştıran bir yardımcı araçtır. 
    6331 sayılı İş Sağlığı ve Güvenliği Kanunu kapsamındaki yasal yükümlülükleriniz geçerliliğini korur. 
    Uygulamamız resmi kayıtlarınızı sizin adınıza üstlenmez; sadece süreci daha pratik, hızlı ve hatasız hale getirmenize destek olur.

              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="heading11">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse11" aria-expanded="false" aria-controls="collapse11">
                Birden fazla OSGB şirketim varsa neden her biri için ayrı lisans ve kayıt yapmam gerekiyor?
              </button>
            </h2>
            <div id="collapse11" className="accordion-collapse collapse" aria-labelledby="heading11" data-bs-parent="#faqAccordion">
              <div className="accordion-body">
                Her OSGB, İSG-KATİP'te ayrı bir kurumsal kayda sahiptir. Bu yüzden Katip Otomasyonu da her şirket için ayrı lisans ve kayıt ile çalışır. Böylece işlemler birbirine karışmaz, her kurum kendi yetki alanında güvenle işlem yapar. Bu hem güvenlik hem de mevzuata uyum açısından sizin yararınıza bir uygulamadır.
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FAQPage;
